export default function Guide() {
  return (
    <div className="-mx-4 -my-6 lg:-mx-8" style={{ height: "calc(100vh - 64px)" }} data-testid="guide-page">
      <iframe
        src="/guide.html"
        title="Pruva Project Tracking — User Guide"
        className="h-full w-full border-0"
        data-testid="guide-iframe"
      />
    </div>
  );
}
